"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterableDataServiceTest = void 0;
const tslib_1 = require("tslib");
const lists_1 = require("src/lists");
const app_1 = require("app");
const FilterableList_1 = require("../FilterableList/FilterableList");
class FilterableDataServiceTest {
    static checkSuccessResultStatus(promise) {
        it('Should return success status if server return valid data', () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield promise;
            global.expect(data).to.exist;
            const listData = data;
            global.expect(listData.status, FilterableDataServiceTest.statusMustExist).to.exist;
            global
                .expect(listData.status.statusCode, 'Status code must be success code')
                .to.equal(FilterableList_1.ListStatusCode.success);
        }));
    }
    static checkFailResultStatus(promise) {
        it('Should return communication error if server not available', () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield promise;
            global.expect(data).to.exist;
            const listData = data;
            global.expect(listData.status, FilterableDataServiceTest.statusMustExist).to.exist;
            global
                .expect(listData.status.statusCode, 'Status code must be communication error code')
                .to.equal(FilterableList_1.ListStatusCode.communicationError);
        }));
    }
    static checkZeroResultStatus(promise) {
        it('Should return zero result status if server not available', () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield promise;
            global.expect(data).to.exist;
            const listData = data;
            global.expect(listData.status, FilterableDataServiceTest.statusMustExist).to.exist;
            global
                .expect(listData.status.statusCode, 'Status code must be zero result code')
                .to.equal(FilterableList_1.ListStatusCode.zeroResults);
        }));
    }
    static checkZeroResultMessage(promise) {
        it('Should return zero results message if items not found ', () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield promise;
            global.expect(data).to.exist;
            const listData = data;
            global.expect(listData.zeroResultsMessage, 'zero result message must exist').to.exist;
        }));
    }
    static checkCollapsed(promise, expectedCollapsedItemsPromise) {
        it('Group filter items should be collapsed correctly', () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield promise;
            global.expect(data).to.exist;
            const expectedCollapsedItems = yield expectedCollapsedItemsPromise;
            const listData = data;
            const collapsedFilters = listData.filters.filter(item => item.isCollapsed);
            collapsedFilters.forEach(item => {
                const collapsed = expectedCollapsedItems.some(expectedItem => {
                    return item.value === (0, lists_1.removePrefix)(expectedItem.filterValue, app_1.FACET_PREFIX);
                });
                const message = `Expected filter with typeAlias ${item.value} to be collapsed`;
                global.expect(collapsed, message).to.be.true;
            });
        }));
    }
}
exports.FilterableDataServiceTest = FilterableDataServiceTest;
FilterableDataServiceTest.statusMustExist = 'status must exist';
